import { atom } from 'jotai';
import { ReactNode } from 'react';

export const isSidebarOpenAtom = atom<boolean>(false);

export const toastShowAtom = atom<boolean>(false);

export const toastMessageAtom = atom<string>('');

export const toastStatusAtom = atom<'SUCCESS' | 'ERROR' | 'INFO'>('SUCCESS');

export const toastTimeoutAtom = atom<ReturnType<typeof setTimeout>|undefined>();

export const loadingAtom = atom<boolean>(false);

export const isModalOpenAtom = atom<boolean>(false);

export const modalChildrenAtom = atom<ReactNode|null>(null);

export const modalCancelableAtom = atom<boolean>(false);

export const isBottomSheetOpenAtom = atom<boolean>(false);

export const bottomSheetChildrenAtom = atom<ReactNode | null>(null);

export const bottomSheetTitleAtom = atom<string>('');
